var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningTriangle = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32816_128111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.21195 2.01262L10.2086 8.93457C10.2808 9.05957 10.3188 9.20137 10.3188 9.34572C10.3189 9.49007 10.2809 9.63188 10.2087 9.75689C10.1365 9.88191 10.0327 9.98572 9.90771 10.0579C9.78269 10.1301 9.64088 10.1681 9.49653 10.168L1.50382 10.168C1.35947 10.1681 1.21766 10.1301 1.09264 10.0579C0.967632 9.98572 0.86382 9.88191 0.79165 9.75689C0.719479 9.63188 0.68149 9.49007 0.681504 9.34572C0.681517 9.20137 0.719531 9.05957 0.791725 8.93456L4.78798 2.01262C4.86014 1.88764 4.96392 1.78386 5.0889 1.7117C5.21388 1.63955 5.35565 1.60156 5.49996 1.60156C5.64427 1.60156 5.78604 1.63955 5.91102 1.7117C6.036 1.78386 6.13979 1.88764 6.21195 2.01262Z",
    fill: "#FF6E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44808 4.14844L5.55234 4.14844C5.80901 4.14844 6.01709 4.35651 6.01709 4.61319L6.01709 6.83463C6.01709 7.0913 5.80901 7.29938 5.55234 7.29938L5.44808 7.29938C5.19141 7.29938 4.98333 7.0913 4.98333 6.83463L4.98333 4.61319C4.98333 4.35651 5.19141 4.14844 5.44808 4.14844Z",
    fill: "#F6E7DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50021 9.0611C5.21474 9.0611 4.98333 8.82969 4.98333 8.54422C4.98333 8.25876 5.21474 8.02734 5.50021 8.02734C5.78567 8.02734 6.01709 8.25876 6.01709 8.54422C6.01709 8.82969 5.78567 9.0611 5.50021 9.0611Z",
    fill: "#F6E7DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32816_128111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 11 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningTriangle);
export default ForwardRef;